import axios from "axios";
import * as ActionType from "./video.type";
import { setToast } from "../../util/toast";
import { apiInstanceFetch } from "../../util/api";
import { apiInstance } from "../../util/api-new";

export const getVideoCategory =
  (type, start, limit, startDate, endDate) => (dispatch) => {
    apiInstanceFetch
      .get(`admin/videoCategory/fetchVideoCategories`)
      .then((res) => {
        dispatch({
          type: ActionType.GET_VIDEO_CATEGORY,
          payload: {
            videoCategory: res.data,
          },
        });
      })
      .catch((error) => console.error(error));
  };

export const addVideoCategory = (formData) => (dispatch) => {
  axios
    .post("admin/videoCategory/createVideoCategory", formData)
    .then((res) => {
      if (res.data.status === true) {
        dispatch({
          type: ActionType.VIDEO_CATEGORY_ADD,
          payload: res.data.data,
        });
        setToast("success", "Sound Category Created Successfully !");
      }
    })
    .catch((error) => console.error(error));
};

export const editVideoCategory = (id, data) => (dispatch) => {
  axios
    .patch(
      `admin/videoCategory/updateVideoCategory?videoCategoryId=${id}`,
      data,
    )
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.VIDEO_CATEGORY_EDIT,
          payload: { editData: res.data.data, id: id },
        });
        setToast("success", "Sound Category Edit SuccessFully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => console.log("error", error.message));
};

export const videoCategoryActiveOrNot = (id, data) => (dispatch) => {
  axios
    .patch(`admin/videoCategory/isVideoCategoryActive?videoCategoryId=${id}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.VIDEO_CATEGORY_SWITCH,
          payload: { id1: id, data1: res.data.data },
        });
        setToast("success", "Sound Category Switch SuccessFully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => console.log("error", error.message));
};

export const getVideoApi = (query) => (dispatch) => {
  const queryParams = new URLSearchParams(query);

  apiInstanceFetch
    .get(`admin/video/videosOrShorts?${queryParams}`)
    .then((res) => {
      dispatch({
        type: ActionType.GET_VIDEO,
        payload: {
          video: res.videosOrShorts,
          totalVideo: res.totalVideosOrShorts,
        },
      });
    })
    .catch((error) => console.error(error));
};

export const getFakeUserName = () => (dispatch) => {
  apiInstanceFetch
    .get(`admin/user/getUsersAddByAdminForChannel`)
    .then((res) => {
      dispatch({
        type: ActionType.GET_FAKE_USER_NAME,
        payload: res.users,
      });
    })
    .catch((error) => console.error(error));
};

export const createVideo = (formData) => (dispatch) => {
  axios
    .post("admin/video/uploadVideo", formData)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.IMPORT_VIDEO,
          payload: {
            data: res.data.videosOrShorts,
            totalNumber: res.data.totalVideosOrShorts,
          },
        });
        setToast("success", "Video created Successfully !");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => console.error(error));
};

export const isLiveToogle = (id, type, data) => (dispatch) => {
  apiInstanceFetch
    .patch(`admin/video/isVideoPublished?videoId=${id}`)
    .then((res) => {
      console.log("res", res);
      if (res.status) {
        dispatch({
          type: ActionType.LIVE_TOGGLE,
          payload: { data: res, id: id, type: type },
        });

        setToast(
          "success",
          data === true
            ? `Video Published SuccessFully`
            : "Video Unpublished SuccessFully",
        );
      } else {
        setToast("error", res.message);
      }
    })
    .catch((error) => console.log("error", error.message));
};

export const editVideo =
  (data, videoId, userId, channelIdFind, type) => (dispatch) => {
    axios
      .patch(
        `admin/video/updateVideo?videoId=${videoId}&userId=${userId}&channelId=${channelIdFind}&videoType=${type}`,
        data,
      )
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: ActionType.EDIT_VIDEO,
            payload: {
              data: res.data.video,
              videoId: videoId,
            },
          });
          setToast(
            "success",
            `${
              type === 1 ? "Video Edit SuccessFully" : "Short Edit SuccessFully"
            }`,
          );
        } else {
          setToast("error", res.data.message);
        }
      })
      .catch((error) => console.log("error", error.message));
  };

export const deleteVideo = (id) => (dispatch) => {
  axios
    .delete(`admin/video/deleteVideo?videoId=${id}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.DELETE_VIDEO, payload: { id: id } });
        setToast("success", "Video Delete SuccessFully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => console.log(error));
};

export const getCommentsApi = (query) => (dispatch) => {
  const queryParams = new URLSearchParams(query);

  apiInstanceFetch
    .get(`admin/VideoComment/commentsOfVideos?${queryParams}`)
    .then((res) => {
      dispatch({
        type: ActionType.COMMENT_GET,
        payload: {
          videoComments: res.commentsOfVideos,
          totalVideoComment: res.totalComments,
        },
      });
    })
    .catch((error) => console.error(error));
};

export const deleteVideoComments = (id) => (dispatch) => {
  axios
    .delete(`admin/videoComment/deleteVideoComment?videoCommentId=${id}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.DELETE_VIDEO_COMMENTS,
          payload: { id: id },
        });
        setToast("success", "Comment Delete SuccessFully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => console.log(error));
};

export const getOrgVideo = (query) => (dispatch) => {
  const queryParams = new URLSearchParams(query);

  apiInstance
    .get(`organization/videos?${queryParams}`)
    .then((res) => {
      dispatch({
        type: ActionType.GET_VIDEO,
        payload: {
          video: res.videosOrShorts,
          totalVideo: res.totalVideosOrShorts,
        },
      });
    })
    .catch((error) => console.error(error));
};

export const createOrgVideo = (formData) => (dispatch) => {
  return apiInstance
    .post("organization/videos", formData)
    .then((res) => {
      if (res.status) {
        dispatch({
          type: ActionType.IMPORT_VIDEO,
          payload: {
            data: res.data,
          },
        });
        setToast("success", "Video uploaded Successfully!");
      } else {
        setToast("error", res.data.message);
      }
      return res;
    })
    .catch((error) => ({ status: false }));
};

export const toggleOrgVideoPublish = (id, type, data) => (dispatch) => {
  apiInstance
    .patch(`organization/videos/${id}/toggle-publish`)
    .then((res) => {
      console.log("res", res);
      if (res.status) {
        dispatch({
          type: ActionType.LIVE_TOGGLE,
          payload: { data: res, id: id, type: type },
        });
      }
    })
    .catch((error) => console.log("error", error.message));
};

export const updateOrgVideo =
  (data, videoId, userId, channelIdFind, type) => (dispatch) => {
    apiInstance
      .put(
        `organization/videos/${videoId}?userId=${userId}&channelId=${channelIdFind}&videoType=${type}`,
        data,
      )
      .then((res) => {
        console.log("UPDATED ", res);

        if (res.status) {
          dispatch({
            type: ActionType.EDIT_ORG_VIDEO,
            payload: {
              data: res.video,
              videoId: videoId,
            },
          });
          setToast(
            "success",
            `${
              type === 1 ? "Video Edit SuccessFully" : "Short Edit SuccessFully"
            }`,
          );
        } else {
          setToast("error", res.message);
        }
      })
      .catch((error) => console.log("error", error.message));
  };

export const deleteOrgVideo = (id) => (dispatch) => {
  apiInstance
    .delete(`organization/videos?videoId=${id}`)
    .then((res) => {
      if (res.status) {
        dispatch({ type: ActionType.DELETE_VIDEO, payload: { id: id } });
        setToast("success", "Video Delete SuccessFully");
      } else {
        setToast("error", res.message);
      }
    })
    .catch((error) => console.log(error));
};
